import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';

import { Icon } from '@components/base';
import ImageTypeToggle from '@components/media/images/ImageTypeToggle';
import useGlobalViewMode from '@hooks/useGlobalViewMode';
import { getOppositeViewMode } from '@hooks/useGlobalViewMode/context';

const GlobalViewMode: FC = () => {
  const { t } = useTranslation();
  const { contentViewMode, imageType, setImageType, toggleViewMode } = useGlobalViewMode();

  return (
    <Fragment>
      <Tooltip title={t('viewAs', { context: getOppositeViewMode(contentViewMode) })}>
        <IconButton onClick={toggleViewMode} size='medium'>
          <Icon name={contentViewMode} />
        </IconButton>
      </Tooltip>

      <ImageTypeToggle imageType={imageType} setImageType={setImageType} />
    </Fragment>
  );
};

export default GlobalViewMode;
